import React, { Fragment } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Icon } from "@mui/material";
import { useNavigate } from "react-router-dom";

const drawerWidth = 240;

interface Props {
  window?: () => Window;
}

export default function ResponsiveDrawer(props: Props) {
  const { window, menus, menuTopic } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <Toolbar />
      <List style={{ padding: "0px 0px" }}>
        {menuTopic.map((topic, key) => (
          <MenuTopic
            topic={topic}
            menus={menus.filter((j) => j.childOf === topic.id)}
            key={key}
          />
        ))}
      </List>
      <Divider />
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap>
            CMUL Digital Payment
          </Typography>
        </Toolbar>
      </AppBar>
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: drawerWidth,
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
    </Box>
  );
}

function MenuTopic({ topic, menus }) {
  const navigate = useNavigate();
  return (
    <>
      {menus.length > 0 && (
        <Fragment>
          <Divider />
          <ListItem disablePadding>
            <ListItemText>
              <div
                style={{
                  fontSize: "1.2rem",
                  fontWeight: 500,
                  paddingLeft: "13px",
                  lineHeight: "40px",
                }}
              >
                {topic.label}
              </div>
            </ListItemText>
          </ListItem>
          <Divider />
          {menus &&
            menus.map((menu, index) => (
              <ListItem key={index} disablePadding>
                {menu.reload ? (
                  <ListItemButton
                    href={process.env.PUBLIC_URL + menu.path}
                    component="a"
                  >
                    <ListItemIcon sx={{ minWidth: "35px" }}>
                      <Icon>{menu.icon}</Icon>
                    </ListItemIcon>
                    <ListItemText component="div" primary={menu.label} />
                  </ListItemButton>
                ) : (
                  <ListItemButton
                    onClick={() => navigate(process.env.PUBLIC_URL + menu.path)}
                  >
                    <ListItemIcon sx={{ minWidth: "35px" }}>
                      <Icon>{menu.icon}</Icon>
                    </ListItemIcon>
                    <ListItemText component="div" primary={menu.label} />
                  </ListItemButton>
                )}
              </ListItem>
            ))}
        </Fragment>
      )}
    </>
  );
}
